export default "__VITE_ASSET__Ba1aXI4F__"